import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import { registerSW } from 'virtual:pwa-register';

// Service worker registratie (gebruik globale scope als dat je bedoeling is)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', {
            scope: '/login'  // Maak de service worker globaal voor de hele app
        }).then(registration => {
            console.log('Service Worker geregistreerd met scope:', registration.scope);
        }).catch(error => {
            console.error('Fout bij het registreren van service worker:', error);
        });
    });
}

const updateSW = registerSW({
    onNeedRefresh() {
        if (confirm('Er is een nieuwe versie beschikbaar. Nu updaten?')) {
            updateSW(); // Update de service worker
        }
    },
    onOfflineReady() {
        console.log('App is klaar voor offline gebruik');
    },
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Provider>
);
